import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

export function saveComment(id, comments) {
  return axios.post(`${apiUrl}/collaborator-comments`, { id, comments })
}